
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"1612","height":"241"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#16A59E","stroke-dasharray":"8","stroke-width":"1.1","d":"M1611.18 118.032S1477.21 9.637 1266.02 1.284c-124.42-4.922-245.446 55.08-403.75 144.008-131.056 73.62-325.27 129.971-543.618 67.826-87.911-25.02-230.925-32.208-325.972-1.126"}})])
          )
        }
      }
    